import { SYNCFUSION_LICENSE_KEY } from "./shared-constants";

export const environment = {
  applicationInsights: {
    appId: "Identity",
    enableConsoleLogging: true,
    instrumentationKey: "a27d5b18-afbc-4efe-af43-680568b698f1",
    rethrowException: false,
  },
  auth: {
    authority: "https://alpha-auth.motorcity.systems",
    clientId: "id",
  },
  gaugeBaseUrl: "https://alpha-gauge-api.motorcity.systems",
  identityBaseUrl: "https://alpha-identity-api.motorcity.systems",
  geolocationBaseApiUrl: "https://alpha-geoloc-api.motorcity.systems",
  adminBaseUrl: "https://alpha-admin-api.motorcity.systems",
  name: "alpha",
  production: true,
  version: {
    hash: "{{POST_BUILD_ENTERS_VERSION_HASH_HERE}}",
    version: "{{POST_BUILD_ENTERS_VERSION_NUMBER_HERE}}",
  },
  identityAppUrl: "https://alpha-identity.motorcity.systems",
  syncfusionLicenseKey: SYNCFUSION_LICENSE_KEY,
};
